import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item', 'search', 'empty']

  connect () {
    this.mediaFilter = 'all'
  }

  select (event) {
    const item = event.currentTarget
    document.dispatchEvent(new globalThis.CustomEvent('cartoonize:gallery-selected', {
      detail: {
        url: item.dataset.mediaUrl,
        mediaType: item.dataset.mediaType,
        filename: item.dataset.filename,
        contentType: item.dataset.contentType
      }
    }))

    const modalElement = this.element.closest('.modal')
    const modal = globalThis.bootstrap?.Modal.getInstance(modalElement)
    if (modal) modal.hide()
  }

  filter (event) {
    this.mediaFilter = event.currentTarget.dataset.mediaFilter
    this.element.querySelectorAll('[data-media-filter]').forEach(button => {
      button.classList.toggle('active', button === event.currentTarget)
    })
    this.applyFilters()
  }

  search () {
    this.applyFilters()
  }

  applyFilters () {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const matchesType = this.mediaFilter === 'all' || item.dataset.mediaType === this.mediaFilter
      const matchesSearch = !query || item.dataset.filename.toLowerCase().includes(query)
      const visible = matchesType && matchesSearch
      item.hidden = !visible
      if (visible) visibleCount += 1
    })

    this.emptyTarget.hidden = visibleCount > 0
  }
}
